import { ToastContainer, toast } from 'react-toastify';
import ErrorBoundary from './ErrorBoundary';
import GoogleConversionTracker from './GoogleConversionTracker';
import Application from './Application';

/*
 * Root route element for the data router. Reproduces the app-shell tree that
 * previously lived under Providers: ErrorBoundary must wrap the tree from inside
 * the router so its NotFound fallback can call useLocation().
 */
const App = () => (
    <ErrorBoundary>
        <GoogleConversionTracker />
        <Application />
        <ToastContainer
            autoClose={8000}
            draggable={false}
            position={toast.POSITION.BOTTOM_CENTER}
            theme="colored"
        />
    </ErrorBoundary>
);

export default App;
